<template>
  <aside class="bg-dark">
    <h1 id="titlelogo">
      <router-link
        class="navi-item"
        to='/'
        active-class="active"
      >
        <img width="36" height="36" src="@/assets/ico_footprint.svg">
        <span>PASTI</span>
      </router-link>
    </h1>

    <ul>
      <template v-if="isAuthenticated">
        <li>
          <router-link
            class="navi-item"
            to="/dailycheck"
            active-class="active"
          >
            <img width="36" height="36" src="@/assets/ico_checklist.svg">
            <span>デイリーチェック</span>
          </router-link>
        </li>
        <li>
          <router-link
            class="navi-item"
            to="/kennel"
            active-class="active"
          >
            <img width="36" height="36" src="@/assets/ico_dog.svg">
            <span>畜舎</span>
          </router-link>
        </li>
        <li>
          <router-link
            class="navi-item"
            to="/log"
            active-class="active"
          >
            <img width="36" height="36" src="@/assets/ico_data.svg">
            <span>記録</span>
          </router-link>
        </li>
        <li>
          <router-link
            class="navi-item"
            to="/account"
            active-class="active"
          >
            <img width="36" height="36" src="@/assets/ico_settings.svg">
            <span>ブリーダー設定</span>
          </router-link>
        </li>
        <li>
          <span
            class="navi-item"
            @click='logout'
            active-class="active"
          >
            <img width="36" height="36" src="@/assets/ico_logout.svg">
            <span>ログアウト</span>
          </span>
        </li>
      </template>
      <template v-else>
        <li >
          <router-link
            class="navi-item"
            to="/login"
            active-class="active"
          >
            <img width="36" height="36" src="@/assets/ico_login.svg">
            <span>ログイン</span>
          </router-link>
        </li>
      </template>

    </ul>

  </aside>

</template>

<script>
export default {
  methods: {
    logout() {
      if(confirm('ログアウトしますか？')){
        this.$store.dispatch("Authorize/logout")
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['Authorize/isAuthenticated']
    }
  }
}
</script>

<style scoped>
.router-link-active:not(.navbar-brand) {
  font-weight: bold;
  color: #111!important;
}
</style>